import React from "react";

const MagnifyingGlass = () => (
  <svg
    width="16px"
    height="18px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Desktop-|-Client-Search-results"
      transform="translate(-174.000000, -362.000000)"
      fill="#000000"
    >
      <g id="Group-2" transform="translate(165.000000, 349.000000)">
        <path
          d="M20.4351058,22.0628931 L19.707833,22.0628931 L19.4562607,21.8113208 C20.352773,20.7730132 20.89251,19.4236707 20.89251,17.946255 C20.89251,14.6620926 18.2304174,12 14.946255,12 C11.6620926,12 9,14.6620926 9,17.946255 C9,21.2304174 11.6620926,23.89251 14.946255,23.89251 C16.4236707,23.89251 17.7730132,23.352773 18.8113208,22.4608348 L19.0628931,22.7124071 L19.0628931,23.4351058 L23.6369354,28 L25,26.6369354 L20.4351058,22.0628931 Z M14.946255,22.0628931 C12.672956,22.0628931 10.8296169,20.219554 10.8296169,17.946255 C10.8296169,15.672956 12.672956,13.8296169 14.946255,13.8296169 C17.219554,13.8296169 19.0628931,15.672956 19.0628931,17.946255 C19.0628931,20.219554 17.219554,22.0628931 14.946255,22.0628931 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

export default MagnifyingGlass;
